import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-qui-sommes-nous',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './qui-sommes-nous.component.html',
  styleUrl: './qui-sommes-nous.component.scss'
})
export class QuiSommesNousComponent implements OnInit {
  title = 'Notre Histoire';
  subtitle = '';
  heroImage = 'assets/static_pages_images/01_La_creation_d_Adam.jpg';
  
  breadcrumbs = [
    { label: 'Notre Histoire', link: undefined }
  ];

  prevPage = {
    title: 'Accueil',
    link: '/landing'
  };

  nextPage = {
    title: 'Notre Approche',
    link: '/notre-approche'
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
